import axios from 'axios';

const getPriceFilterApi = async (langIsoCode) => {
  try {
    const url = '/General/priceFilter';
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default getPriceFilterApi;
